import { ImportTestTemplateModeView } from 'common/enum';
import { useState } from 'react';
import SelectFileView from './SelectFileView';
import EditTemplateView from './EditTemplateView';
import { useDispatch } from 'react-redux';
import { AppDispatch } from '../../../redux/store/store';
import { initExamEdit } from '../../../redux/slice/examEditSlice';
import { updateLoading } from '../../../redux/slice/appConfigSlice';
import processError from '../../../utils/processError';
import { findExamTemplatesById } from '../../../service/examTemplateService';
import { docImport } from '../../../service/docImportService';
import { useMasterSubjectsSelector } from '../../../redux/selector';

interface ImportViewProps {
  type?: 'exam' | 'practice';
}

export default function ImportView({ type = 'exam' }: ImportViewProps) {
  const [modeView, setModeView] = useState(ImportTestTemplateModeView.SELECT_FILE);
  const dispatch = useDispatch<AppDispatch>();
  const subjects = useMasterSubjectsSelector();

  const importFile = async function (file: any, examTemplateId: string) {
    try {
      dispatch(updateLoading(true));
      const examImportRequest = await docImport(file, examTemplateId, type === 'practice');
      const examTemplate = await findExamTemplatesById(examTemplateId);
      const subject =
        examImportRequest && examImportRequest.subject
          ? subjects.find((subject) => subject.id === examImportRequest.subject?.id)
          : null;
      setModeView(ImportTestTemplateModeView.EDIT_TEMPLATE);
      dispatch(
        initExamEdit({
          examTemplate: examTemplate,
          examImportRequest,
          subject: subject || null,
          practice: type === 'practice',
        }),
      );
    } catch (error) {
      processError(error);
    }
    dispatch(updateLoading(false));
  };

  return (
    <>
      {modeView === ImportTestTemplateModeView.SELECT_FILE ? (
        <SelectFileView type={type} onCommitFile={importFile} />
      ) : (
        <EditTemplateView
          type={type}
          moveToSelectFileView={() => setModeView(ImportTestTemplateModeView.SELECT_FILE)}
        />
      )}
    </>
  );
}
